import { Middleware } from "@nuxt/types"

const influencerFetchMiddleware: Middleware = function ({
  route,
  redirect,
  from,
}) {
  if (
    !process.client ||
    (!from.path.includes(route.path) &&
      !from.path.endsWith("/draft/influencers/") &&
      !from.path.includes("/favorites/") &&
      !from.path.includes("/influencer/profile/"))
  ) {
    return redirect(`${route.path}loading/`)
  }
}

export default influencerFetchMiddleware
